
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investing-101",
      function () {
        return require("private-next-pages/investing-101.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/investing-101"])
      });
    }
  